import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'selectBookWalkRoute',
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      services: [],
      lang: '',

      bookList: [],
      walkList: [],
      book: '',
      walk: '',
      walkId: 0
    }
  },
  created() {
    this.$root.$on('select_book_walk_route_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.services = this.dataObj.services;

        this.bookList = this.services.books;
        this.walkList = this.services.walks;

        this.getCurrentBookWalk();
      });
    },
    getCurrentBookWalk() {
      var parameter = {
        ApplicationId: this.app.id,
        ApplicationKey: 0
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/SelectAgreementsActivity/GetAgreements', parameter),
        response => {
          if (response.status == 200) {
            this.book = response.data.item.book;
            this.walk = response.data.item.walk;
            this.walkId = response.data.item.walkId;

            this.$root.$emit('select_book_walk_route_updated');
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //axios.post('/SelectBookWalkActivity/GetCurrentBookWalk', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      console.log(response.data);


      //      this.book = response.data.item.book;
      //      this.walk = response.data.item.walk;
      //      this.walkId = response.data.item.walkId;

      //      this.$root.$emit('select_book_walk_route_updated');
      //    }
      //  })
      //  .catch(error => {
      //    this.$alertMsg(error.response.data);
      //  });
    },
    selectBookWalk() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        book: this.book,
        walk: this.walk,
        walkId: Number(this.walk)
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/SelectAgreementsActivity/GetAgreements', parameter),
        response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.SelectBookWalkSuccess'), 2);
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/SelectBookWalkActivity/SelectBookWalk', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.$alertMsg(this.$t('messages.SelectBookWalkSuccess'), 0);
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.data);
      //  });
    }
  },
}
